import {createAction, props} from '@ngrx/store';

export const showMenu = createAction(
  '[Core/Menu] Show Menu'
);

export const hideMenu = createAction(
  '[Core/Menu] Hide Menu'
);

export const toggleMenu = createAction(
  '[Core/Menu] Toggle Menu'
);

export const setActiveTab = createAction(
  '[Core/Menu] Set Active Tab',
  props<{tab: any}>()
);

export const lastClickedTab = createAction(
  '[Core/Menu] Last Clicked Tab',
  props<{tab: any}>()
);

export const openMobileMenu = createAction(
  '[Core/Menu] Open Mobile Menu',
);

export const closeMobileMenu = createAction(
  '[Core/Menu] Close Mobile Menu',
);

export type MenuActionsUnion = ReturnType<
  typeof showMenu |
  typeof hideMenu |
  typeof toggleMenu |
  typeof setActiveTab |
  typeof lastClickedTab |
  typeof openMobileMenu |
  typeof closeMobileMenu
  >;
